<template>
  <modal 
    name="products-details-modal"
    @before-open="handleBeforeOpen"
    style="z-index: 1001;"
  >
    <div id="modal-header" class="w-100 px-4 py-2 position-relative"
         style="background-color:#1e7bb7">
      <div class="w-100 d-flex">
        <h4 class="text-white">Չափաբաժնի ամբողջական նկարագիր</h4>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 30%"
              @click="$modal.hide('products-details-modal')" aria-label="Close">
        <span aria-hidden="true" class="text-white">&times;</span>
      </button>
    </div>
    <div id="modal-body" class="p-4" style="overflow-x: auto; height: 85%">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group col-md-12">
            <div class="mb-3 pl-1">
              <label for="firm_name">Ֆիրմային անվանումը</label>
              <input 
                v-model="row.firm_name"
                type="text"
                class="form-control"
              >
            </div>
          </div>
          <div class="form-group col-md-12">
            <div class="mb-3 pl-1">
              <label for="trademark">Ապրանքային նշանը</label>
              <input 
                v-model="row.trademark"
                type="text"
                class="form-control"
              >
            </div>
          </div>
          <div class="form-group col-md-12">
            <div class="mb-3 pl-1">
              <label for="brand">Մակնիշը</label>
              <input 
                v-model="row.brand"
                type="text"
                class="form-control"
              >
            </div>
          </div>
          <div class="form-group col-md-12">
            <div class="mb-3 pl-1">
              <label for="manufacturer">Արտադրողի անվանումը</label>
              <input 
                v-model="row.manufacturer"
                type="text"
                class="form-control"
              >
            </div>
          </div>
          <div class="form-group col-md-12">
            <div class="mb-3 pl-1">
              <label for="specification">Տեխնիկական բնութագրերը</label>
              <input 
                v-model="row.specification"
                type="text"
                class="form-control"
              >
            </div>
          </div>
          <div v-if="cpv_type === 'work'" class="form-group col-md-12">
            <div class="mb-3 pl-1">
              <label for="specification">Երաշխիքային ժամկետները</label>
              <input 
                v-model="row.guarantee_time"
                type="text"
                class="form-control"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="modal-footer" class="position-absolute w-100 p-3 text-center" style="bottom: 0">
      <button @click="save" class="btn btn-primary mr-3">
        Պահպանել
      </button>
    </div>
  </modal>
</template>

<script>
  import { requiredIf } from "vuelidate/lib/validators";
  import 'vue-date-pick/dist/vueDatePick.css';

  export default {
    name: 'ProductsDetailsModal',
    components: {  },
    data() {
      return {
        procedure_type: null,
        cpv_type: 'product',
        row: {
          firm_name: ' ',
          trademark: ' ',
          brand: ' ',
          manufacturer: ' ',
          specification: ' ',
          guarantee_time: ' ',
        },
      }
    },
    validations: {
      row: {
        firm_name: {  },
        trademark: {  },
        brand: {  },
        manufacturer: {  },
        specification: { required: requiredIf(function() {
          return this.procedure_type  !== 'ELAH'
        })  },
        // guarantee_time: { required: requiredIf(function(item) {
        //   return this.cpv_type === 'work'
        // }) },
        guarantee_time: { },
      },
    },
    computed: {
      currentOrganized() {
        return this.$store.getters['organize/currentOrganized']
      },
    },
    methods: {
      handleBeforeOpen({params}) {
        this.procedure_type = params.procedure_type
        this.index = params.index
        this.row = params.row
        this.setProductDetails = params.setProductDetails
        this.cpv_type = params.cpv_type
      },
      save() {
        if(!this.$v.row.$invalid) {
          this.setProductDetails(this.row, this.index);
          this.$modal.hide('products-details-modal')
        } else {
          this.$notify({
            group: 'foo',
            type: 'error',
            text: 'Լրացրեք տեխնիկական բնութագրեր դաշտը, պահպանելու համար!'
          })
        }
      }
    }
  }
</script>

<style scoped>
 .date-picker {
    display: block;
    width: 100%;
    border: 1px solid #e8ebf3;
    border-radius: .25rem;
    border-bottom: 1px solid #e8ebf3;
  }
  /deep/ .vdpWithInput > input {
    width: 100%;
    height: calc(1.8em + .75rem + 2px);
    padding: .375rem .75rem;
    font-size: .845rem;
    font-weight: 400;
    line-height: 1.8;
    color: #303e67;
    border: none;
  }
  /deep/ .vm--modal {
    top: 0 !important;
    bottom: 0 !important;
    right: 0 !important;;
    left: 0 !important;;
    margin: auto;
    position: absolute;
    width: 500px !important;
    height: 80% !important;
    -webkit-border-radius: .3rem !important;
    -moz-border-radius: .3rem !important;
    border-radius: .3rem !important;
  }
</style>